




































import {
    Vue,
    Component,
    Prop
} from "@/shared/vuepack";
import { useWexDebitCardsStore } from "@/shared/store/wexDebitCards";
import { useNotifierStore } from "@/shared/store/notifier";
import { CardWexRecord } from "@/shared/types";

@Component({
    components: {
    }
})
export default class WexDebitCardNewCardRequestModal extends Vue {
    notifierStore = useNotifierStore();
    wexDebitCardsStore = useWexDebitCardsStore();

    @Prop()
    wexDebitCardsList: CardWexRecord [];

    formIsBeingSubmitted = false;
    selectedPrimaryAccountHolder = null;
    selectedSecondaryAccountHolder = [];

    get modalOpen () {
        return this.wexDebitCardsStore.wexNewCardRequestModalOpen;
    }
    set modalOpen (value: boolean) {
        this.wexDebitCardsStore.setNewCardRequestModalOpen(value);
    }

    get primaryAccountHolder () {
        return this.wexDebitCardsList[0];
    }

    get secondaryAccountHolders () {
        return this.wexDebitCardsList.slice(1).map(cardHolder => ({
            text: `${cardHolder.firstName} ${cardHolder.lastName}`,
            value: `${cardHolder.firstName} ${cardHolder.lastName}`
        }));
    }

    onSecondaryOptionChange () {
        this.selectedPrimaryAccountHolder = null;
    }

    onPrimaryOptionChange () {
        this.selectedSecondaryAccountHolder = [];
    }

    onSubmitChanges (e: Event) {
        e.preventDefault();
        this.formIsBeingSubmitted = true;

        if (this.selectedPrimaryAccountHolder !== null) {
            this.notifierStore.setSuccess(
                `New card requested for ${this.primaryAccountHolder.firstName} ${this.primaryAccountHolder.lastName}`);
        }
        if (this.selectedSecondaryAccountHolder.length !== 0 ) {
            this.notifierStore.setSuccess(
                `New card requested for ${this.selectedSecondaryAccountHolder}`);
        }

        // Hide the modal manually
        this.wexDebitCardsStore.setNewCardRequestModalOpen(false);
    }
}
